export default __webpack_public_path__ + "static/media/vobbIcon.ffe2a3fe.svg";